type ValidationResult = {
  exists: boolean
  contentLength: string | null
}

export default class AssetURLValidator {
  public static async validate(url: string): Promise<ValidationResult> {
    const response = await fetch(url, {
      method: 'HEAD',
    })
    return {
      exists: response.ok,
      contentLength: response.headers.get('content-length'),
    }
  }
}
